import React from 'react';
import PropTypes from 'prop-types';

function IconToggleOff({ color = `#88898B`, className }) {
  return (
    <svg width="40" height="24" viewBox="0 0 40 24" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.00012207" width="40" height="24" rx="12" fill={color}/>
      <circle cx="12.0001" cy="12" r="10" fill="#121212"/>
    </svg>
  )
}

IconToggleOff.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string
}


export default IconToggleOff;
